import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
export class FormlyWrapperDescription extends FieldWrapper {
   fieldComponent: ViewContainerRef;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-wrapper-description',
  template: `
    <ng-template #fieldComponent></ng-template>
    <div>
      <small class="text-muted">{{ to.description }}</small>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fieldComponent': [{ type: ViewChild, args: ['fieldComponent', {read: ViewContainerRef}, ] },],
};
}

function FormlyWrapperDescription_tsickle_Closure_declarations() {
/** @type {?} */
FormlyWrapperDescription.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyWrapperDescription.ctorParameters;
/** @type {?} */
FormlyWrapperDescription.propDecorators;
/** @type {?} */
FormlyWrapperDescription.prototype.fieldComponent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
